import React from 'react'
import { Link } from 'react-router-dom'
import { Button, Container, Grid } from 'semantic-ui-react';
import { OVERLAY_VALUES } from '../constants';

const ButtonColumn = (props) => (
  <Grid.Column computer={4} tablet={4} mobile={5}>
    <Link to={`/overlay/${props.id}`}>
      <Button content={props.content} primary basic size='massive' fluid style={{padding: '32px 0'}}/>
    </Link>
  </Grid.Column>
);

const copyrightStyle = {
  color: 'white',
  backgroundColor: 'gainsboro',
  padding: '2px'
}
const Main = () => (
  <Container>
    <Grid centered padded='vertically'> 
      { Object.keys(OVERLAY_VALUES).map(key => <ButtonColumn key={key} id={key} content={OVERLAY_VALUES[key]}/> ) }
      <Grid.Column width={16} textAlign='center' style={copyrightStyle}>
        © 2019 - poker planner apps
      </Grid.Column>
    </Grid>
  </Container>
);

export default Main



// WEBPACK FOOTER //
// ./src/components/Main.js